import { useState } from 'react';
import ExoDialog from '../../components/exo/ExoDialog';
import { FormControls } from '../../components/exo/ExoForm';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import { ExoRichTextEditor } from '../../components/exo/ExoRichTextEditor';

export const ClockOutComment = ({ open, onClose, onSubmit }) => {
  const { t } = useTranslation();
  const [comment, setComment] = useState('');

  function handleSubmit() {
    // check if there is a valid text without html tags
    // Parse the HTML into a DOM node
    const div = document.createElement('div');
    div.innerHTML = comment;

    // Extract just the text content
    const text = div.textContent || '';

    // Trim whitespace and measure length
    const cleanText = text.trim();

    onSubmit(cleanText.length > 1 ? comment : null);

    setComment('');
  }

  return (
    <ExoDialog
      open={open}
      onClose={onClose}
      className="flex flex-col gap-2"
      limitWidth
    >
      <Box className="flex flex-col gap-2 pt-2">
        <Typography variant="h3">{t('Activities')}</Typography>
        <Typography variant="p">
          {t('Briefly describe what you did during your working hours')}
        </Typography>
        <ExoRichTextEditor onHtmlChange={setComment} />
      </Box>
      <FormControls
        isValid={true}
        onSubmit={handleSubmit}
        submitText={t('Clock Out')}
      />
    </ExoDialog>
  );
};
